import { ACTION_TYPES } from '../constants/actions';
import { buildGaErrorMeta } from '../helpers/dataLayerHelpers';

export const initialState = {
  searchNumbers: {
    numbers: [],
    signature: undefined,
    loading: false,
    error: false,
    _gaErrorMeta: ''
  },
  reserveResource: {
    success: true,
    loading: false,
    error: false
  }
};

const ngnisReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_SEARCH_NUMBERS':
      return {
        ...state,
        searchNumbers: {
          ...initialState.searchNumbers
        }
      };
    case 'SET_SEARCH_NUMBERS_SUCCESS':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: action.value.numbers,
          signature: action.value.signature,
          loading: false,
          error: false
        }
      };
    case 'SET_SEARCH_NUMBERS_LOADING':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: [],
          signature: undefined,
          loading: action.value,
          error: false
        }
      };
    case 'SET_SEARCH_NUMBERS_ERROR':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: [],
          signature: undefined,
          loading: false,
          error: true,
          redirectNeeded: false,
          _gaErrorMeta: buildGaErrorMeta({
            isBlocker: false,
            errorType: 'popup',
            featureName: 'ngnis',
            errorReason: 'searchNumbersFailed',
            errorName: 'Number search failed'
          })
        }
      };

    case 'VALIDATE_NGNIS_ADDRESS_LOADING': {
      return {
        ...state,
        loading: true
      };
    }

    case 'VALIDATE_NGNIS_ADDRESS_SUCCESS': {
      return {
        ...state,
        loading: false,
        validateAddress: action.value,
        isNgnisAddress: true
      };
    }

    case 'VALIDATE_NGNIS_ADDRESS_ERROR': {
      return {
        ...state,
        loading: false,
        error: true,
        validateAddress: action.value
      };
    }

    case 'VALIDATE_NGNIS_ADDRESS_RESET': {
      return {
        ...state,
        loading: false,
        validateAddress: undefined,
        isNgnisAddress: true
      };
    }

    case ACTION_TYPES.DELIVERY.UPDATE_ADDRESS_INFO: {
      return {
        ...state,
        validateAddress: undefined
      };
    }

    case ACTION_TYPES.ERROR.RESET_ERROR_STATE: {
      return {
        ...state,
        error: false,
        searchNumbers: {
          ...state.searchNumbers,
          error: false
        }
      };
    }

    default:
      return state;
  }
};

export default ngnisReducer;
